<template>
  <div
    v-tooltip="{
      content: tooltipHTML,
      html: true,
      placement: 'auto',
      classes: 'otp-tooltip',
      trigger: 'hover',
    }"
    class="stacked-bar-chart"
    @click="handleClick"
  >
    <div class="bar-container">
      <div v-if="data.late" class="bar-segment late" :style="{ width: `${data.late}%` }">
        <span v-if="data.late > 5" class="segment-label">{{ data.late }}%</span>
      </div>
      <div v-if="data.onTime" class="bar-segment on-time" :style="{ width: `${data.onTime}%` }">
        <span v-if="data.onTime > 5" class="segment-label">{{ data.onTime }}%</span>
      </div>
      <div v-if="data.early" class="bar-segment early" :style="{ width: `${data.early}%` }">
        <span v-if="data.early > 5" class="segment-label">{{ data.early }}%</span>
      </div>
      <div v-if="data.skipped" class="bar-segment skipped" :style="{ width: `${data.skipped}%` }">
        <span v-if="data.skipped > 5" class="segment-label">{{ data.skipped }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
import { generateRouteTooltipHTML } from '../utils/otpFormatters';

export default {
  name: 'StackedBarChart',
  props: {
    data: {
      type: Object,
      required: true,
    },
    routeId: {
      type: [String, Number],
      default: null,
    },
    routeName: {
      type: String,
      default: '',
    },
    dateRange: {
      type: Object,
      default: null,
    },
    stopId: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    tooltipHTML() {
      // Calculate realistic counts from percentages if not provided
      const totalStops = this.data.totalStops ?? 0;
      const lateCount = this.data.lateCount ?? Math.round((this.data.late / 100) * totalStops);
      const earlyCount = this.data.earlyCount ?? Math.round((this.data.early / 100) * totalStops);
      const skippedCount = this.data.skippedCount ?? Math.round((this.data.skipped / 100) * totalStops);
      const leftBehind = this.data.leftBehind ?? 0;

      const tooltipData = {
        routeName: this.routeName,
        dateRange: this.dateRange || this.data.dateRange || { start: '2024-01-01', end: '2024-01-31' },
        totalStops,
        lateCount,
        earlyCount,
        skippedCount,
        leftBehind,
        late: this.data.late ?? 0,
        onTime: this.data.onTime ?? 0,
        early: this.data.early ?? 0,
        skipped: this.data.skipped ?? 0,
      };

      return generateRouteTooltipHTML(tooltipData, this.$t.bind(this));
    },
  },
  methods: {
    handleClick() {
      this.$emit('bar-click', {
        routeId: this.routeId,
        stopId: this.stopId,
        data: this.data,
      });
    },
  },
};
</script>

<style scoped>
.stacked-bar-chart {
  width: 100%;
  cursor: pointer;
}

.bar-container {
  display: flex;
  width: 100%;
  height: 30px;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f5f5;
}

.bar-segment {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  transition: opacity 0.2s;
}

.bar-segment:hover {
  opacity: 0.8;
}

.segment-label {
  color: white;
  font-size: 0.75rem;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.late {
  background-color: #ff4059;
}

.on-time {
  background-color: #687692;
}

.early {
  background-color: #5287e3;
}

.skipped {
  background-color: #97a0b4;
}
</style>
